module.exports = __webpack_public_path__ + "static/media/blue_sky_thumb_even.06f266da.webp";